import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Cancel extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7,21.8l-6.2-5.8c-0.4-0.3-0.9-0.3-1.3,0l-5.7,5.8
        c-0.4,0.4-0.9,0.4-1.3,0l-2-2c-0.4-0.4-0.4-1,0-1.3l5.6-5.7c0.4-0.4,0.4-1,0-1.3L2.4,5.8c-0.3-0.4-0.4-0.9,0-1.3l1.9-2.1
        c0.4-0.4,1-0.4,1.3,0L11.2,8c0.4,0.4,0.9,0.4,1.3,0l5.6-5.7c0.4-0.4,0.9-0.4,1.3,0l2,2c0.4,0.4,0.4,1,0,1.3l-5.6,5.7
        c-0.4,0.4-0.4,1,0,1.3l6,6.1c0.4,0.4,0.4,1,0,1.3L20,21.7C19.6,22.1,19,22.1,18.7,21.8z"
                />
            </SvgIcon>
        );
    }
}

export default Cancel;
